export var FlexBasisProp;
(function (FlexBasisProp) {
    FlexBasisProp["auto"] = "auto";
    FlexBasisProp["ignore"] = "0%";
})(FlexBasisProp || (FlexBasisProp = {}));
